
import React, { useEffect } from 'react';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { makeStyles, fade } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
// import { mainListItems, secondaryListItems } from './listItems';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import MenuListComposition from './MenuListComposition';

import api from './../services/axios'

import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import MoreIcon from '@material-ui/icons/MoreVert';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function Nav({
  titleHeader = '',
  handleDrawerMenu,
  logoutAction,
  badgeContent=null,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [redirect, setRedirect] = React.useState(null);
  const [notifications, setNotifications] = React.useState([]);
  const [notificationsLength, setNotificationsLength] = React.useState(null);
  const [loadDataFlag, setLoadDataFlag] = React.useState(false);
  const [openNotifications, setOpenNotifications] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [idNotification, setIdNotification] = React.useState([]);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  function handleProfileMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  function handleMenuClose() {
    setAnchorEl(null);
    handleMobileMenuClose();
  }
  function toPerfil() {
    // handleMenuClose()
    window.location = '/perfil';
  }

  function handleMobileMenuOpen(event) {
    setMobileMoreAnchorEl(event.currentTarget);
  }
  
  const askNotificationPermission = function askNotificationPermission() {

    console.log('askNotificationPermission...')

    function checkNotificationPromise() {
      try {
        Notification.requestPermission().then();
      } catch(e) {
        return false;
      }
  
      return true;
    }

    // function to actually ask the permissions
    function handlePermission(permission) {
      // set the button to shown or hidden, depending on what the user answers
      if(Notification.permission === 'denied' || Notification.permission === 'default') {
        console.log('notificação bloqueada', Notification.permission)
      } else {
        console.log('notificação ativa', Notification.permission)
      }
    }
  
    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
      console.log("This browser does not support notifications.");
    } else {
      if(checkNotificationPromise()) {
        Notification.requestPermission()
        .then((permission) => {
          handlePermission(permission);
        })
      } else {
        Notification.requestPermission(function(permission) {
          handlePermission(permission);
        });
      }
    }
  }

  const load = ( async ()=>{
    const data = await api.get('/v1/refresh?limit=0');
    setNotifications(data.data.notifications);
    const len = data.data.notifications && data.data.notifications.length>0 ? data.data.notifications.length : null;
    setLoadDataFlag(true)
    const lastNotification = data && data.data && data.data.notifications.length>0 && data.data.notifications[data.data.notifications.length-1]
    const notificationId = lastNotification && lastNotification.id ? lastNotification.id : null;
    let nNew = JSON.parse(localStorage.getItem('idNotification'));
    if(typeof nNew !== 'object' || (!nNew || nNew.length<1)){
      nNew = data.data.notifications || [];
    }
    if(nNew && nNew.length>0){
      for(let n in data.data.notifications){
        let notificationId = data.data.notifications[n].id;
        const exist = nNew.find((i, k)=>parseInt(i)===parseInt(notificationId));
        if(typeof exist === 'undefined'){
          nNew.push(notificationId)
            var img = '/to-do-notifications/img/icon-128.png';
            var title = data.data.notifications[n].title;
            var message = data.data.notifications[n].message;
            var notification = new Notification(title, { 
              body: message, 
              // icon: img 
            });
        }
      }
      localStorage.setItem('idNotification', JSON.stringify(nNew));
      setIdNotification(nNew);
      setNotificationsLength(data.data.notificationsTotal);
    }
  })

  const loadData = async (loadDataFlag) => {
      // load();
      // const loadInterval = setInterval( async ()=>{
      //   load()
      // }, 5000);
  }

  const sentNotificacaoCheck = async (idN) => {

    const data = new FormData();
    data.append('sent', 1);
    data.append('_method', 'PUT')
    try {      
      const res = await api.post('/v1/notifications/' + idN, data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      load();
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  useEffect(() => {
    loadData();  
  }, []);

  useEffect(() => {
    askNotificationPermission();  
  }, [])

  useEffect(() => {
  }, [idNotification])

  useEffect(() => {
  }, [notificationsLength])

  useEffect(() => {
  }, [notifications])

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenNotifications(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpenNotifications(false);
    }
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={toPerfil}>Meu Perfil</MenuItem>
      {/* <MenuItem onClick={handleMenuClose}>Minha conta</MenuItem> */}
      <MenuItem onClick={logoutAction}>Sair</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
     { redirect && <Redirect to={redirect}/> }
      <Toolbar>
        <IconButton
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="open drawer"
          onClick={()=>handleDrawerMenu()}
        >
          <MenuIcon />
        </IconButton>
        <Typography className={classes.title} variant="h6" noWrap>
          {titleHeader}
          </Typography>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder="Pesquisar..."
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
          />
        </div>
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
          <MenuListComposition 
            onClose={(id)=>{
              sentNotificacaoCheck(id)
            }}
            notifications={notifications} notificationsLength={notificationsLength} />
          <IconButton aria-label="show 4 new mails" color="inherit">
            {/* <Badge badgeContent={4} color="secondary"> */}
              <MailIcon />
            {/* </Badge> */}
          </IconButton>
          <IconButton
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
        </div>
        <div className={classes.sectionMobile}>
          <IconButton
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="inherit"
          >
            <MoreIcon />
          </IconButton>
        </div>
      </Toolbar>
      {renderMobileMenu}
      {renderMenu}
    </>
  );
}
